import messageResource from '../../../../messageResource'

export default class LeaveHTMLPreviewBalanceColumnsRender {

    constructor(withSpaces) {
        this.withSpaces = withSpaces
        this.showSickInHours = SystemSettings.showSickInHours
        this.showPTOInHours = SystemSettings.showPTOInHours
        return this
    };

    addHeaderFirstRowCells = (fRow) => {
        //abstract
    }

    addHeaderSecondRowCells = (sRow) => {
        //abstract
    }

    addValueCells = (row) => {
        //abstract
    }

    getRenderSpecificCssClass = () => {
        //abstract
    }

    _addPTOFRowCells = (row) => {
        ReportPreviewUtils.addCreatedCell(row, this._getBalanceTypeCell("report.leaves.pto_column.preview.html.pto_balance"))
    }

    _addSickDaysFRowCells = (row) => {
        ReportPreviewUtils.addCreatedCell(row, this._getBalanceTypeCell("report.leaves.pto_column.preview.html.sick_days_balance"))
    }

    _addRangeSRowCells = (inHours, row) => {
        ReportPreviewUtils.addCreatedCell(row, this._getRangeCell(inHours, "report.leaves.pto_column.preview.html.beginning"))
        ReportPreviewUtils.addCreatedCell(row, this._getRangeCell(inHours, "report.leaves.pto_column.preview.html.ending"))
    }

    _getBalanceTypeCell = (textKey) => {
        return ReportPreviewUtils.createCell(messageResource.getMessage(textKey), "balanceCell", 2, 1)
    }

    _getRangeCell = (inHours, textKey) => {
        return ReportPreviewUtils.createCell(messageResource.getMessage(textKey, [this._getHoursOrDays(inHours)]), "balanceRangeCell")
    }

    _getHoursOrDays = (inHours) => {
        if (inHours) {
            return messageResource.getMessage("common.pto_units.hours")
        }
        return messageResource.getMessage("common.pto_units.days")
    }

    _addBalanceValueCell = (row) => {
        ReportPreviewUtils.addCreatedCell(row, ReportPreviewUtils.createCell("12" + SystemSettings.decimalSeparator + "345", "balanceValueCell"))
    }

    _addEmptyCellIfNeed = (row) => {
        if (this.withSpaces) {
            ReportPreviewUtils.addCell(row, "", "emptyCell")
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewBalanceColumnsRender.js